import React from 'react';
import { useRecordContext } from 'react-admin';

import resourceTypes, { ResourceTypes } from '../../constants/resourceTypes';
import IAuditTrack from '../../utilities/schemas/auditTrack';

import AccountEntityAuditDetails from '../accountEntity/AccountEntityAuditDetails';
import AnalysisAuditDetails from '../analysis/AnalysisAuditDetails';
import ApiKeyAuditDetails from '../apiKey/ApiKeyAuditDetails';
import BusinessAuditDetails from '../business/BusinessAuditDetails';
import CarAuditDetails from '../car/CarAuditDetails';
import CaseAuditDetails from '../case/CaseAuditDetails';
import CaseTransactionSnapshotAuditDetails from '../caseTransactionSnapshot/CaseTransactionSnapshotAuditDetails';
import FormAuditDetails from '../form/FormAuditDetails';
import GroupAuditDetails from '../group/GroupAuditDetails';
import IndividualAuditDetails from '../individual/IndividualAuditDetails';
import NoResults from '../layout/NoResults';
import MemberAuditDetails from '../member/MemberAuditDetails';
import PermissionRoleAuditDetails from '../permissionRoles/PermissionRoleAuditDetails';
import PingAuditDetails from '../ping/PingAuditDetails';
import ProcessAuditDetails from '../process/ProcessAuditDetails';
import ProductAuditDetails from '../product/ProductAuditDetails';
import ReportAuditDetails from '../report/ReportAuditDetails';
import RequestAuditDetails from '../request/RequestAuditDetails';
import ReviewAuditDetails from '../reviews/ReviewAuditDetails';
import RiskClassAuditDetails from '../riskClass/RiskClassAuditDetails';
import RuleAuditDetails from '../rule/RuleAuditDetails';
import RuleVersionAuditDetails from '../rule/RuleVersionAuditDetails';
import SignalAuditDetails from '../signal/SignalAuditDetails';
import TagAuditDetails from '../tag/TagAuditDetails';
import TransactionTypeAuditDetails from '../transactionType/TransactionTypeAuditDetails';

export const AUDIT_RESOURCE_DETAILS: Partial<Record<ResourceTypes, React.ReactElement>> = {
  [resourceTypes.ACCOUNT_ENTITY]: <AccountEntityAuditDetails />,
  [resourceTypes.ANALYSIS]: <AnalysisAuditDetails />,
  [resourceTypes.API_KEY]: <ApiKeyAuditDetails />,
  [resourceTypes.BUSINESS]: <BusinessAuditDetails />,
  [resourceTypes.CAR]: <CarAuditDetails />,
  [resourceTypes.CASE]: <CaseAuditDetails />,
  [resourceTypes.CASE_TRANSACTION_SNAPSHOT]: <CaseTransactionSnapshotAuditDetails />,
  [resourceTypes.FORM]: <FormAuditDetails />,
  [resourceTypes.GROUP]: <GroupAuditDetails />,
  [resourceTypes.INDIVIDUAL]: <IndividualAuditDetails />,
  [resourceTypes.MEMBER]: <MemberAuditDetails />,
  [resourceTypes.PERMISSION_ROLE]: <PermissionRoleAuditDetails />,
  [resourceTypes.PING]: <PingAuditDetails />,
  [resourceTypes.PROCESS]: <ProcessAuditDetails />,
  [resourceTypes.PRODUCT]: <ProductAuditDetails />,
  [resourceTypes.REPORT]: <ReportAuditDetails />,
  [resourceTypes.REQUEST]: <RequestAuditDetails />,
  [resourceTypes.REVIEW]: <ReviewAuditDetails />,
  [resourceTypes.RISK_CLASS]: <RiskClassAuditDetails />,
  [resourceTypes.RULE]: <RuleAuditDetails />,
  [resourceTypes.RULE_VERSION]: <RuleVersionAuditDetails />,
  [resourceTypes.SIGNAL]: <SignalAuditDetails />,
  [resourceTypes.TAG]: <TagAuditDetails />,
  [resourceTypes.TRANSACTION_TYPE]: <TransactionTypeAuditDetails />,
};

export const isRowExpandable = (record: IAuditTrack) => (
  !!AUDIT_RESOURCE_DETAILS[record.resource.type]
  && (!!record.documentAfter || !!record.extraInfo)
);

const AuditDetails = () => {
  const record = useRecordContext<IAuditTrack>();
  if (!record) return <NoResults />;
  if (isRowExpandable(record)) return AUDIT_RESOURCE_DETAILS[record.resource.type];
  return <NoResults />;
};

export default AuditDetails;
